import { IApplicationState } from '../../types/redux';

export function getMvkData(state: IApplicationState) {
  return state.mvk.mvkData;
}
